import { render } from "./CategoryService.vue?vue&type=template&id=37c56fbc"
import script from "./CategoryService.vue?vue&type=script&lang=js"
export * from "./CategoryService.vue?vue&type=script&lang=js"

import "./CategoryService.vue?vue&type=style&index=0&id=37c56fbc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__